module.exports = __webpack_public_path__ + "static/img/yk8210.8d6d29d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk8210.png
// module id = rl0L
// module chunks = 1